import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet, Modal } from 'react-native';
import { Text, AppText } from '../../../components/ui/AppText';
import { LinearGradient } from 'expo-linear-gradient';
import Animated, { SlideInUp, FadeIn, ZoomIn } from 'react-native-reanimated';
import * as Haptics from 'expo-haptics';

const AnimatedText = Animated.createAnimatedComponent(AppText);

const ChallengeSentModal = memo(({
    visible,
    opponentUsername,
    onStartDuel,
    onClose,
}) => {
    const handleAcknowledge = () => {
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        if (onClose) {
            onClose();
            return;
        }
        onStartDuel?.();
    };

    if (!visible) return null;

    return (
        <Modal visible={visible} transparent animationType="none" statusBarTranslucent onRequestClose={handleAcknowledge}>
            <Animated.View entering={FadeIn.duration(200)} style={styles.overlay}>
                <Animated.View entering={SlideInUp.springify()} style={styles.modal}>
                    <LinearGradient
                        colors={['rgba(45, 35, 75, 0.98)', 'rgba(26, 11, 46, 0.99)']}
                        style={StyleSheet.absoluteFill}
                    />

                    {/* Success Icon */}
                    <AnimatedText entering={ZoomIn.delay(200).springify()} style={styles.icon}>
                        ⏳
                    </AnimatedText>

                    {/* Title */}
                    <Text style={styles.title}>Convite enviado!</Text>

                    {/* Description */}
                    <Text style={styles.description}>
                        @{opponentUsername} recebeu seu convite de duelo.{'\n'}
                        Assim que aceitar, voce sera notificado para duelar ao vivo.
                    </Text>

                    {/* Divider */}
                    <View style={styles.divider} />

                    {/* Call to Action */}
                    <Text style={styles.cta}>Aguardando resposta do oponente.</Text>

                    {/* Start Button */}
                    <TouchableOpacity
                        style={styles.startButtonContainer}
                        onPress={handleAcknowledge}
                        activeOpacity={0.8}
                    >
                        <LinearGradient
                            colors={['#9333EA', '#7C3AED']}
                            style={styles.startButton}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        >
                            <Text style={styles.startIcon}>⏱️</Text>
                            <Text style={styles.startText}>Aguardar Oponente</Text>
                        </LinearGradient>
                    </TouchableOpacity>
                </Animated.View>
            </Animated.View>
        </Modal>
    );
});

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 24,
    },

    modal: {
        width: '100%',
        borderRadius: 24,
        padding: 28,
        alignItems: 'center',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.1)',
        overflow: 'hidden',
    },

    icon: {
        fontSize: 72,
        marginBottom: 16,
    },

    title: {
        fontSize: 24,
        fontWeight: '700',
        color: '#34C759',
        marginBottom: 12,
        textAlign: 'center',
    },

    description: {
        fontSize: 15,
        color: 'rgba(255, 255, 255, 0.7)',
        textAlign: 'center',
        lineHeight: 22,
        marginBottom: 16,
    },

    divider: {
        width: 60,
        height: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 1,
        marginBottom: 16,
    },

    cta: {
        fontSize: 16,
        fontWeight: '600',
        color: '#FFFFFF',
        marginBottom: 20,
    },

    startButtonContainer: {
        width: '100%',
        borderRadius: 14,
        overflow: 'hidden',
    },

    startButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 16,
        gap: 10,
    },

    startIcon: {
        fontSize: 18,
    },

    startText: {
        fontSize: 16,
        fontWeight: '700',
        color: '#FFFFFF',
    },
});

export default ChallengeSentModal;
